import { FetcherResult } from "../api-client/fetcher";
import { PostResponse, usePost } from "../api-client/usePost";
import { useCartNext } from "../stores/hooks/useCartNext";
import { useDealerAccountInfo } from "../stores/hooks/useDealerAccountInfo";
import {
  AnyOrderItem,
  IncludedOptionalLineItem,
  OrderDetails,
} from "../stores/slices/cartSlice";
import { useGetNewCart } from "./useGetNewCart";

type RemoveLineItemFromCart = (
  orderItem: Pick<AnyOrderItem, "orderItemId">,
  lineItem: Pick<IncludedOptionalLineItem, "lineItemId">
) => Promise<FetcherResult<OrderDetails>>;

export const useRemoveLineItemFromCart = (): Omit<
  PostResponse<OrderDetails>,
  "send"
> & {
  send: RemoveLineItemFromCart;
} => {
  const init = useGetNewCart();
  const { send: removeItemFromCart, ...post } = usePost<OrderDetails>(
    "/retailSiteWebService/shopping/cart/removeLineItemFromCart.php"
  );
  const { dealerId } = useDealerAccountInfo();
  const cartNext = useCartNext();
  const send: RemoveLineItemFromCart = async (
    { orderItemId },
    { lineItemId }
  ) => {
    const { orderNumber } = await init();
    const response = await removeItemFromCart({
      cartId: orderNumber,
      cartItemId: orderItemId,
      dealerId,
      isNational: "0",
      lineItemId,
      orderNumber,
    });
    cartNext(response.payload);
    return response;
  };
  return { ...post, send };
};
